/* ============================================================
   DATA APOTEK

   Letakkan di: app/layanan/apotek/apotek.js

   Alamat halamannya /layanan/apotek - sudah ditunjuk menu Header,
   dan sebelum berkas ini ada, menu itu jatuh ke halaman 404
   "Sedang Dalam Proses Pengembangan".

   ============================================================
   ⚠️ YANG BELUM DIISI - BACA DULU SEBELUM TAYANG

   Berkas ini sengaja dibiarkan kosong di beberapa bagian. Tidak
   ada satu pun keterangan operasional apotek yang pernah
   diberikan, dan mengarang jam buka rumah sakit lebih berbahaya
   daripada membiarkan halaman tanpa keterangan: orang bisa datang
   jam 10 malam karena membaca "24 jam" yang tidak pernah
   dikonfirmasi siapa pun.

   Yang HARUS ditanyakan ke bagian farmasi sebelum tayang:

     1. jamLayanan  - apotek buka jam berapa sampai jam berapa?
                      Apakah 24 jam mengikuti IGD, atau ada jam
                      tutup sendiri?
     2. LAYANAN     - apa saja yang dilayani? Resep dokter dalam,
                      resep dokter luar, obat bebas, alat kesehatan?
     3. CATATAN     - apakah menerima BPJS/asuransi? Apakah resep
                      dari luar RS bisa ditebus di sini?
     4. Nomor       - apakah apotek punya nomor sendiri, atau tetap
                      lewat customer service seperti di bawah?

   Selama LAYANAN dan CATATAN kosong, bagiannya tidak dirender -
   halaman tetap tampil rapi, hanya lebih pendek.
   ============================================================ */

export const APOTEK = {
  /* ⚠️ BELUM DIKONFIRMASI. Selama null, lencana jam di kepala
     halaman tidak dirender.

     Kalau sudah pasti, isi begini:
       jamLayanan: { id: "Setiap hari, 24 jam", en: "Daily, 24 hours" }
     atau:
       jamLayanan: { id: "Senin-Sabtu, 07.00 - 21.00", en: "..." } */
  jamLayanan: null,

  /* Nomor yang sama dengan halaman Laboratorium dan IGD - diambil
     dari lab.js, bukan karangan.

     ⚠️ Kalau apotek/farmasi punya nomor ekstensi sendiri, tambahkan
     di sini. Nomor dengan medan `wa` membuka WhatsApp beserta pesan
     pembuka; sisanya membuka aplikasi telepon. */
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],

  alamat: {
    baris: "Jl. Warung Buncit Raya No. 15, RT 10/RW 05, Kalibata, Kec. Pancoran, Jakarta Selatan 12740",
    /* Pencarian berdasarkan nama dan alamat, bukan koordinat - kalau
       titiknya digeser di Google Maps, tautannya tetap benar. */
    cari: "Rumah Sakit Jakarta Medical Center, Jl. Warung Buncit Raya No. 15, Jakarta Selatan",
  },
};

/* ============================================================
   PESAN PEMBUKA WHATSAPP

   Terisi otomatis di kolom ketik saat nomor customer service
   ditekan. WhatsApp hanya MENGISI, tidak mengirim - pasien masih
   bisa menyunting sebelum menekan kirim.

   Menyebut apotek secara eksplisit supaya customer service langsung
   tahu konteksnya tanpa bertanya dulu.
   ============================================================ */
export const PESAN_WA = {
  id: "Halo RS Jakarta Medical Center,\n\nSaya ingin menanyakan informasi mengenai layanan apotek.\n\nMohon bantuannya. Terima kasih.",
  en: "Hello RS Jakarta Medical Center,\n\nI would like to ask about the pharmacy services.\n\nThank you for your help.",
};

/* ============================================================
   JENIS LAYANAN APOTEK

   ⚠️ MASIH KOSONG - DIISI SETELAH KONFIRMASI BAGIAN FARMASI.

   Jangan diisi dari tebakan. Yang tampak "pasti" pun belum tentu
   benar: banyak apotek rumah sakit TIDAK melayani resep dari luar,
   dan menuliskan sebaliknya membuat orang datang jauh-jauh
   membawa resep yang lalu ditolak di loket.

   Bentuknya sama dengan halaman MCU dan Laboratorium, supaya
   kartunya seragam:

     {
       kode: "Resep",
       nama: { id: "Penebusan resep dokter", en: "Prescription dispensing" },
       julukan: { id: "Untuk pasien rawat jalan", en: "For outpatients" },
       catatan: { id: "Bawa kartu identitas dan resep asli.", en: "..." },
       harga: null,   // null -> kartunya menampilkan "Hubungi kami"
     },

   `harga` hampir selalu null di halaman ini - harga obat berbeda
   tiap item dan berubah, jadi lebih jujur mengarahkan orang
   bertanya daripada memasang angka yang cepat basi.
   ============================================================ */
export const LAYANAN = [];

/* ============================================================
   FOTO

   ⚠️ PERIKSA NAMA BERKASNYA. Path di bawah menunjuk ke
   public/images/layanan/apotek.jpg

   Kalau berkasmu berekstensi .png atau .jpeg, ubah barisnya. Salah
   ekstensi = gambar tidak muncul, tanpa pesan error yang jelas.

   Cara memastikan: buka http://localhost:3005/images/layanan/apotek.jpg
   di tab baru. Kalau gambarnya tampil, path-nya benar.

   CATATAN TEKNIS - kenapa ada `lebar` dan `tinggi` di sini,
   sementara lab.js tidak punya:

   lab.js memakai `import foto1 from "./images/1.jpg"`. Next.js
   membaca ukuran gambarnya saat build, jadi tidak perlu ditulis,
   dan bonusnya dapat efek blur saat gambar dimuat.

   Berkas dari folder public/ hanya berupa teks alamat - Next.js
   tidak tahu ukurannya, jadi harus disebut manual. Angka di bawah
   dipakai sebagai perbandingan sisi saat foto dibuka besar; tidak
   harus persis, tapi lebih dekat lebih baik.
   ============================================================ */
export const FOTO = [
  {
    gambar: "/images/layanan/apotek.png",
    lebar: 1600,
    tinggi: 1200,
    judul: { id: "Apotek RS JMC", en: "RS JMC Pharmacy" },
    alt: {
      id: "Apotek Rumah Sakit Jakarta Medical Center.",
      en: "The pharmacy at Jakarta Medical Center Hospital.",
    },
  },
];

/* ============================================================
   CATATAN OPERASIONAL

   ⚠️ MASIH KOSONG. Bagiannya tidak dirender selama kosong.

   Yang layak ditulis di sini setelah dikonfirmasi - dan hanya
   setelah dikonfirmasi:
     - apakah resep dari dokter luar RS bisa ditebus
     - apakah menerima BPJS atau asuransi tertentu
     - berapa lama rata-rata resep disiapkan
     - apakah obat bisa diantar (kalau ya, tautkan ke halaman
       Delivery Obat yang sudah ada)

   Bentuknya: { id: "...", en: "..." }
   ============================================================ */
export const CATATAN = [];

/* ============================================================
   TAUTAN KE HALAMAN TERKAIT

   /layanan/delivery-obat SUDAH ADA dan berfungsi - sudah diperiksa,
   bukan tautan karangan. Orang yang membuka halaman apotek sering
   sebenarnya mencari pengantaran obat, jadi tautannya ditaruh di
   sini daripada membiarkan mereka menebak sendiri.

   Kalau halaman itu suatu saat dipindah atau dihapus, kosongkan
   larik ini - bagiannya ikut hilang, tidak ada tautan mati.
   ============================================================ */
export const TERKAIT = [
  {
    href: "/layanan/delivery-obat",
    judul: { id: "Delivery Obat", en: "Medicine Delivery" },
    ringkas: {
      id: "Pengantaran obat untuk pasien yang tidak bisa datang langsung.",
      en: "Medicine delivery for patients who cannot come in person.",
    },
  },
];
